import type { OrganizationPreferencesDto } from '../generated/model/organizationPreferencesDto';

export const createPreferredParty = (
  overrides: Partial<OrganizationPreferencesDto> = {},
): OrganizationPreferencesDto => ({
  ownPreferences: [
    {
      marketParticipantEanCode: '8712423010208',
      marketRole: 'DDQ',
      product: '_23',
      statutoryName: 'Gummy Bear B.V.',
    },
    {
      marketParticipantEanCode: '8712423010208',
      marketRole: 'DDQ',
      product: '_27',
      statutoryName: 'Gummy Bear B.V.',
    },
    {
      marketParticipantEanCode: '9256472682164',
      marketRole: 'CTO',
      product: '_27',
      statutoryName: 'Daily Sushi B.V.',
    },
  ],
  preferredByParties: [
    {
      accountId: '12345678',
      marketParticipantEanCode: '8712423010322',
      marketRole: 'DDQ',
      product: '_27',
      statutoryName: 'Oreo Cookies B.V.',
      subjectDescription: 'Leveringszekerheid',
      subjectId: '9abf46b6-c432-ea11-a813-000d3a24f3f0',
    },
    {
      accountId: 'c6f7e4a2-7dc6-ea11-a816-000d3a21145f',
      marketParticipantEanCode: '8712423010333',
      marketRole: 'DDQ',
      product: '_23',
      statutoryName: 'Test Organisatie',
      subjectDescription: 'Leveringszekerheid',
      subjectId: '9abf46b6-c432-ea11-a813-000d3a24f3f0',
    },
    {
      accountId: 'c6f7e4a2-7dc6-ea11-a816-000d3a21145f',
      marketParticipantEanCode: '8712423010333',
      marketRole: 'DDQ',
      product: '_27',
      statutoryName: 'Test Organisatie',
      subjectDescription: 'Leveringszekerheid',
      subjectId: '9abf46b6-c432-ea11-a813-000d3a24f3f0',
    },
  ],
  ...overrides,
});
